const hostname = typeof window !== "undefined" ? window.location.hostname : "";
const isLocalHost =
  hostname === "localhost" ||
  hostname === "127.0.0.1" ||
  hostname === "::1";

export const api = isLocalHost ? "https://localhost:5001" : "https://vatanparvar.uz";
export const url = `${api}/Files/News`;
export const urlFoto = `${api}/Files/Photogallery`;
export const urlStat = `${api}/Files/StatisticElements`;
export const urlPer = `${api}/Files/Personal`;
